import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Eyebrow } from "./Motion";

const Hexagon = ({ progress }) => {
  const rotate = useTransform(progress, [0, 1], [-20, 25]);
  return (
    <motion.svg style={{ rotate }} viewBox="0 0 100 100" className="pointer-events-none absolute -right-32 -top-10 h-[380px] w-[380px] opacity-40 md:-right-16 lg:-top-16 lg:h-[480px] lg:w-[480px]" aria-hidden>
      <polygon points="50,3 91,26.5 91,73.5 50,97 9,73.5 9,26.5" fill="none" stroke="#D4AF37" strokeWidth="0.35" />
      <polygon points="50,15 80.5,32.5 80.5,67.5 50,85 19.5,67.5 19.5,32.5" fill="none" stroke="#D4AF37" strokeWidth="0.2" />
    </motion.svg>
  );
};

const HOME_PARA = "The Krimzon Promise is a commitment by every person at KRIMZON to consistently live these three principles in everything we do — delivering excellence, creating ease and enriching experiences for everyone we work with.";

const HomeStatement = () => (
  <>
    Every interaction. Every solution. Every commitment delivered with{" "}
    <span className="underline decoration-[#D4AF37] decoration-2 underline-offset-[10px]">Excellence</span>,{" "}
    <span className="underline decoration-[#D4AF37] decoration-2 underline-offset-[10px]">Ease</span> and{" "}
    <span className="underline decoration-[#D4AF37] decoration-2 underline-offset-[10px]">Experience</span>.
  </>
);

const Body = ({ children }) => <p className="text-base leading-relaxed text-[#2D6A64] md:text-lg">{children}</p>;

export const KrimzonPromise = ({ statement, paras = [HOME_PARA], lines, list, after }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  return (
    <section ref={ref} className="relative overflow-hidden bg-[#F4F9F8]" data-testid="promise-section">
      <Hexagon progress={scrollYProgress} />
      <div className="relative mx-auto max-w-[1400px] px-6 py-24 lg:px-12 lg:py-40">
        <Reveal>
          <Eyebrow>The Krimzon Promise</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display mt-10 max-w-5xl text-3xl font-bold leading-[1.12] tracking-tight text-[#0D9488] sm:text-5xl lg:text-6xl" data-testid="promise-statement">
            {statement ?? <HomeStatement />}
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="mt-14 grid lg:grid-cols-12">
          <div className="space-y-5 border-l border-[#D4AF37] pl-6 lg:col-span-6 lg:col-start-7">
            {paras.map((p) => <Body key={p}>{p}</Body>)}
            {lines && (
              <div className="space-y-1">
                {lines.map((l) => <p key={l} className="font-display text-xl font-semibold text-[#0D9488] lg:text-2xl">{l}</p>)}
              </div>
            )}
            {list && (
              <div>
                <Body>{list.lead}</Body>
                <ul className="mt-4 space-y-2">
                  {list.items.map((it) => (
                    <li key={it} className="font-display flex items-center gap-3 text-lg font-semibold text-[#0D9488]">
                      <span className="h-2 w-2 rotate-45 bg-[#D4AF37]" />
                      {it}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {after?.map((p) => <Body key={p}>{p}</Body>)}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
